import type { FC } from "react";
import { memo } from "react";

import { languageSelector } from "@/src/contexts";
import { defaultToTrue } from "@Components/Modules/Helpers";
import * as stylex from "@stylexjs/stylex";

import { genericStyles } from "../../styles/tokens.stylex";
import { PageTagsResources } from "./PageTags.Resources";
import { PageTagsResourcesEn } from "./PageTags.Resources.En";

import * as css from "./PageTags.module.css";

export interface IPageTags {
    tags: string[];
}

const PageTags: FC<IPageTags> = memo((props) => {
    const resources = languageSelector(PageTagsResources, PageTagsResourcesEn);

    return (
        props.tags && (
            <section className={`${css.pageTagsComponent} ${stylex.props(styles.border).className}`}>
                <header className={css.title}>
                    <h5 className={css.text}>{resources.title}</h5>
                    <span className={css.comma}>,</span>
                    <span className={css.titleDescription}>{resources.titleDescription}</span>
                </header>
                <div className={css.tags}>{props.tags.join(", ")}</div>
            </section>
        )
    );
}, defaultToTrue);

const styles = stylex.create({
    border: {
        borderRadius: genericStyles.borderRadiusS1,
    },
});

export default PageTags;
